import styled from '@emotion/styled';
import { Checkbox, COLORS } from 'pvs-design-system';
import { FormControlLabel } from '@mui/material';

// Styled FormControlLabel for consistent label styling
export const StyledFormControlLabel = styled(FormControlLabel)({
  width: 'fit-content',
  '& .MuiFormControlLabel-label': {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
});

// Styled checkbox for editable checkboxes (NRPS and AGS main checkboxes)
export const EditableCheckbox = styled(Checkbox)({
  '&.Mui-checked .MuiSvgIcon-root': {
    color: COLORS.purple[700],
  },
  '&.MuiCheckbox-indeterminate .MuiSvgIcon-root': {
    color: COLORS.purple[700],
  },
});

// Styled checkbox for disabled scope checkboxes
export const DisabledCheckbox = styled(Checkbox)({
  '&.Mui-disabled': {
    opacity: 1,
  },
  // Checked disabled checkboxes (score, lineitem.readonly, result.readonly)
  '&.Mui-checked.Mui-disabled .MuiSvgIcon-root': {
    color: COLORS.gray[400],
  },
});

// Styled FormControlLabel for disabled checkboxes with gray 900 text
export const DisabledFormControlLabel = styled(FormControlLabel)({
  width: 'fit-content',
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  '& .MuiFormControlLabel-label.Mui-disabled': {
    color: COLORS.gray[900],
  },
});
